import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CreateProjectDto } from '../models/projects/create-project.dto';
import { Project } from '../models/projects/project.interface';
import { UpdateProjectDto } from '../models/projects/update-project.dto';
import { ProjectOverview } from '../models/projects/project-overview.interface';
import { FindProjectsDto } from '../dtos/find-projects.dto';

@Injectable({
    providedIn: 'root',
})
export class ProjectsService {
    private static readonly BASE_URL = environment.api + 'projects';

    constructor(private readonly http: HttpClient) {}

    findAll(dto: FindProjectsDto = {}): Observable<ProjectOverview[]> {
        let params: HttpParams = new HttpParams();
        for (const [key, value] of Object.entries(dto)) {
            params = params.append(key, String(value));
        }

        return this.http.get<ProjectOverview[]>(ProjectsService.BASE_URL, { params });
    }

    findOne(id: string): Observable<Project> {
        return this.http.get<Project>(ProjectsService.BASE_URL + '/' + id);
    }

    public copy(id: string): Observable<Project> {
        return this.http.get<Project>(`${ProjectsService.BASE_URL}/${id}/copy`);
    }

    public update({ id, dto }: { id: string; dto: UpdateProjectDto }): Observable<Project> {
        return this.http.post<Project>(ProjectsService.BASE_URL + '/' + id, dto);
    }

    create(dto: CreateProjectDto): Observable<Project> {
        return this.http.put<Project>(ProjectsService.BASE_URL, dto);
    }

    delete(id: string): Observable<Project> {
        return this.http.delete<Project>(ProjectsService.BASE_URL + '/' + id);
    }

    archive(id: string): Observable<Project> {
        return this.http.delete<Project>(`${ProjectsService.BASE_URL}/${id}/archive`);
    }

    reactivate(id: string): Observable<Project> {
        return this.http.get<Project>(`${ProjectsService.BASE_URL}/${id}/reactivate`);
    }
}
